{
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_cCJoLDsKb",
    "aws_user_pools_web_client_id": "41ljlle94bqn9hpmlfii6jcci2",
    "identityPoolId": "us-east-1:15085853-639f-4345-b1f5-10785585ba71",
    "mandatorySignIn": true,
    "oauth": {},
    "API": {
        "endpoints": [
            {
                "name": "AirCurtainClientAPI",
                "endpoint": "https://cywz7qz484.execute-api.us-east-1.amazonaws.com"
            },
            {
                "name": "ReportingAPI",
                "endpoint": "https://hug9lf04pg.execute-api.us-east-1.amazonaws.com"
            },
            {
                "name": "WebApplicationAPI",
                "endpoint": "https://lqd5rbn1ze.execute-api.us-east-1.amazonaws.com"
            }
        ]
    }
}
